import {Component, OnInit} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NotificationService } from '../../../Services/notification.service';
import {DataService} from '../../../Services/data.service';
import { Router } from '@angular/router';
import { AppConfigService } from '../../../Services/app-config.service';
import { StorageService } from '../../../Services/storage.service';
import { ResponseModel } from '../../../DataModels/response-model';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../Services/ngbpagination-config.service';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.css'],
  standalone: false
})
export class EmployeeListComponent extends ListPageBase implements OnInit {
  constructor(
    private localStorage: StorageService,
    private titleService: Title,
    private tableDataService: DataService,
    private notification: NotificationService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  vm: any = {
    list: [],
    title: 'Employee List',
    Preferences: [],
    permissions: [],
    listInitiated: false,
    formRoute: '/payroll/employee-form',
  };

  employeeCount = 0;
  isLoaded = false;




  ngOnInit() {
    this.restorePagerState();
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));

    this.titleService.setTitle(this.vm.title);
    this.vm.list = [];
    this.getData();
  }


  getData() {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('employee', paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data ?? [];
      this.totalRecords = result.totalRecords ?? 0;
      this.paginate(false);
      this.vm.listInitiated = true;
      this.employeeCount = result.totalRecords;
      this.isLoaded = true;
    });
  }

  onNavigate(aID: string) {
    this.router.navigate([this.vm.formRoute, { id: aID }]);
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('employee', paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data ?? [];
      this.totalRecords = result.totalRecords ?? 0;
      this.paginate(false);
      this.vm.listInitiated = true;
      this.isLoaded = true;
    });
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }

}
